import './App.css';
import './Header.jsx'
import Header from './Header.jsx';
import HeroPage from './HeroPage.jsx';
import FeaturesPage from './FeaturesPage.jsx';
import About from './About.jsx';
import Home from "./pages/Home.jsx"
import Footer from './Footer.jsx';
import GoogleCallback from './GoogleCallback.jsx'
import StoryPage from './StoryPage.jsx';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Waitlist from './Waitlist.jsx';
import ThankPage from './ThankPage.jsx';
import Login from './pages/Login.jsx';
import {useState} from "react";
import HeaderMain from "./components/HeaderMain.jsx"
import CreatorStudio from './pages/CreatorStudio.jsx';
import Upload from './pages/Upload.jsx';
import TipTapEditor from './components/TipTapEditor.tsx';
function App() {
const [isDark, setIsDark] = useState(false);
const [title, setTitle] = useState("");
  const scrollToFeatures = () => {
  document.getElementById("features").scrollIntoView({
    behavior: "smooth"
  });
};
const savedContent = localStorage.getItem('story-draft');

  return (
    <Router>
    <Routes>
      <Route  path="/" element={
    <div className="">
      <header>
        <Header />
      </header>
      <HeroPage scrollToFeatures={scrollToFeatures}/>
      <section id="features">
      <FeaturesPage/>
      </section>
      <About/>
      <Footer />
      
    </div>
      }
    />
    <Route path="/waitlist" element={<Waitlist/>}/>
   {/** 
    <Route path='/home' element={
      <div>
      <HeaderMain isDark={isDark} setIsDark={setIsDark}/>
      <Home isDark={isDark}/>
      </div>
      }/>
      */}
      <Route path='/thank-you' element={<ThankPage/>}/>
      {/**  
      <Route path='/login' element={<Login/>}/>
      <Route path="/oauth/google" element={<GoogleCallback />} />
      <Route path='/story/:id' element={ 
        <div>
        <HeaderMain isDark={isDark} setIsDark={setIsDark} />
        <StoryPage />
        </div>}/>
        <Route path='/creatorstudio' element={
          <div>
            <HeaderMain isDark={isDark} setIsDark={setIsDark}/>
          <CreatorStudio isDark={isDark} savedContent={savedContent}/>
          </div>
          }/>
          <Route path='/upload' element={
          <div>
            <Upload />
            </div>
          }/>
            <Route path='/new-story' element={
                <div className={isDark? "bg-gray-800 p-12 flex flex-col gap-4" : "bg-custom-browm p-12 flex flex-col gap-4"}>
              <h2 className="text-xl text-white font-bold">Create a new story</h2>
              <input placeholder='Enter story title' className={isDark? "p-2 bg-gray-900 text-white": ""} value={title} />
              <TipTapEditor content={savedContent || "<p>Start writing...</p>"}  isDark={isDark}/>
              <h2 className='text-xl text-white font-bold'>Add picture</h2>
              <div className='p-6 bg-gray-900 w-[250px] rounded-xl flex flex-col'>
                <span className='text-gray-400 mb-2'>Upload preview </span>
              <input type="file"/>
              </div>
              <h2 className='text-xl text-white font-bold'>Choose a category</h2>
              <div className=''> 
                  <select className={isDark? 'w-full bg-gray-900 text-white': 'w-full bg-white text-black'}>
                    <option>Anime</option>
                    <option>Mystic</option>
                    <option>Lord</option>
                    <option>Original</option>
                  </select>
                </div>

              <h2 className='text-xl text-white font-bold'>Write tags</h2>
              < input type="text" placeholder='Enter tags separetes by comas' className={isDark? 'bg-gray-900 text-white rounded-lg': 'bg-white text-black rounded-lg'} />
            <button
              className="px-4 py-2 bg-violet-500 text-white rounded hover:bg-violet-600"
            >
              Save and publish
            </button>
          </div>
            }/>
            */}
    </Routes>
    </Router>
  );
}

export default App;